'use strict'
import SmoothScroll from './includes/_SmoothScroll.js'
import ResizeHelper from './includes/_ResizeHelper.js'
import ScrollHelper from './includes/_ScrollHelper.js'
import Intersection from './includes/_Intersection.js'
import Device from './includes/_Device.js'
import VideoSources from './includes/_VideoSources.js'
import Maps from './_Maps.js'
import CONSTS from './_const.js'

require('desvg')
import Lenis from '@studio-freight/lenis'
import ClipboardJS from 'clipboard';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';

Swiper.use([Navigation, Pagination]);
import Slider from './includes/_Slider.js'
import { remap, clamp } from './includes/_Utility.js'
import TieUpsKV from './TieUpsKV.js'

$(() => {
  const isSP = window.matchMedia(`(max-width: ${CONSTS.BREAK_POINT}px)`)
  const $body = document.querySelector('body')
  const $header = document.querySelector('.js-header')
  $body.classList.add('loaded')

  deSVG('.replace-svg', true);

  new VideoSources('.js-mediavideo', CONSTS.BREAK_POINT)


  const $submenu = document.querySelector('.js-submenu')
  if($submenu) {
    $submenu.addEventListener('mouseenter', _ => {
      $body.classList.add('is-submenu-active')
    })
    $submenu.addEventListener('mouseleave', _ => {
      $body.classList.remove('is-submenu-active')
    })
  }

  const $skip = document.querySelector('.js-skiptomovie')
  if($skip) {
    const $movie = document.querySelector('.js-skiptomovie-pos')
    $skip.addEventListener('click', e => {
      const rect = $movie.getBoundingClientRect()
      document.documentElement.scrollTop = rect.bottom - window.innerHeight
      
    })
  }
  


  const $agreement = document.querySelector('.js-agreement')
  if($agreement) {
    $agreement.addEventListener('change', e => {
      document.querySelector('.js-agreement--target').classList.toggle('--active', e.target.checked)
    })
  }

  // sticky_menu
  const $sticky_menu = document.querySelector('.js-anchor-menu')
  if($sticky_menu) {
    const $target = document.querySelector('.js-anchor-target')
    window.addEventListener('scroll', e => {
      $sticky_menu.classList.toggle('is-sticky', $target.getBoundingClientRect().top < 0)
      $body.classList.toggle('is-sticky', $target.getBoundingClientRect().top < 0)
    })
  
    // sticky_menu active class
    const sticky_menu = document.querySelector('.js-anchor-menu')
    if(sticky_menu) {
      const sticky_target = document.querySelectorAll('.js-anchor-position')
      const stickyObserver = new IntersectionObserver(e => {
        e.forEach(entry => {
          if(entry.isIntersecting) {
            const current = entry.target.getAttribute('id')
            sticky_menu.querySelectorAll('a').forEach(a => {
              a.classList.toggle('--active', a.getAttribute('href') === '#' + current)
            })
          }
        })
      }, {
        rootMargin: `0px 0px -99% 0px`,
      })
      sticky_target.forEach(el => {
        stickyObserver.observe(el)
      })
    }
  }
  

  // header色変更
  const $darkheadertarget = document.querySelectorAll('.js-darkheadertarget')
  // observe
  const menuObserver = new IntersectionObserver(e => {
    e.forEach(entry => {
      $header.classList.toggle('--dark', entry.isIntersecting)
      $body.classList.toggle('is-dark', entry.isIntersecting)
    })
  }, {
    rootMargin: `0px 0px ${-1 * (window.innerHeight - $header.getBoundingClientRect().height)}px 0px`,
    threshold: 0
  })

  $darkheadertarget.forEach(el => {
    menuObserver.observe(el)
  })


  

  const slider = []
  function initSlider(use_swiper) {
    // スライダー配列初期化
    slider.forEach((el, index) => {
      el.destroy()
      delete slider[index]
    })
    slider.splice(0)

    // swiper用クラスの付与・削除
    document.querySelectorAll('.js-slider--item').forEach(el => {
      el.classList.toggle('swiper-slide', use_swiper)
    })
    document.querySelectorAll('.js-slider--wrapper').forEach(el => {
      el.classList.toggle('swiper-wrapper', use_swiper)
    })
  }
  
  new Device({
    breakpoint: CONSTS.BREAK_POINT,
    pc: _ => {
      initSlider(false)
      document.querySelectorAll('.js-slider').forEach(el => {
        slider.push(new Slider(el))
      })
    },
    sp: _ => {
      initSlider(true)
      document.querySelectorAll('.js-slider').forEach((el, index) => {
        slider.push(
          new Swiper(el, {
            slidesPerView: 1,
            loop: false,
            spaceBetween: 0,
            navigation: {
              nextEl: '.js-slider--next',
              prevEl: '.js-slider--prev',
            },
            pagination: {
              el: el.querySelector('.js-slider--current'),
              type: 'fraction',
            },
          })
        )
      })
    }
  })
  
  // smooth scroll
  const lenis = new Lenis({
    duration: .6,
  })
  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
  }
  requestAnimationFrame(raf)

  new TieUpsKV('.js-tieupskv')

  

  // Intersection Observer
  new Intersection('.js-inview', entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-inview')

        // anim-sequenceの場合inviewクラスを削除
        if( entry.target.classList.contains('anim-sequence') ) {
          entry.target.addEventListener('transitionend', e => {
            entry.target.classList.remove('is-inview')
            entry.target.classList.remove('js-inview')
          })
        }
      }
    })
  }, {
    addclass: 'is-inview',
    root: null,
    rootMargin: "0% 0px -20% 0px",
  })


  if(ClipboardJS.isSupported()) {
    const copyText = new ClipboardJS('.js-copy');
    copyText.on('success', e => {
      e.trigger.classList.add('--copied')
      e.trigger.addEventListener('animationend', a => {
        e.trigger.classList.remove('--copied')
      })
    })
  } else {
    document.querySelectorAll('.js-copy').forEach(el => {
      el.style.display = 'none';
    })
  }


  // // sp menu
  $('.js-toggle-menu').on('click', e => {
    const result = $body.classList.toggle('is-menu-active')
    $body.classList.toggle('is-menu-closed', !result)
  })

  $('#js-menu-scrollelement a').on('click', e => {
    const result = $body.classList.remove('is-menu-active')
  })

  function show_thanks() {
    $('.js-contact-body').css('display', 'none')
    $('.js-contact-result').fadeIn()
    document.documentElement.scrollTop = 0
  }
  document.addEventListener( 'wpcf7mailsent', show_thanks, false );

})


